import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import useWindowResize from "../../hooks/useWindowResize";
import Close from "../../public/assets/icons/close.svg";
import styles from "./Steps.module.scss";

const Steps = ({ title, steps }) => {
  const isBelowLarge = useWindowResize(968);
  const [cardContent, setCardContent] = useState(steps.content[0]);
  const [arrows, setArrows] = useState([]);
  const [close, setClose] = useState(false);
  let array = [];

  const handleClick = (d, i) => {
    if (close) {
      setClose(false);
    }
    setCardContent(d);
    array[i] = !array[i];
    setArrows(array);
  };

  const handleClose = () => {
    setClose(true);
    array.fill(false);
    setArrows(array);
  };

  useEffect(() => {
    for (let i = 0; i < steps.content.length; i++) {
      if (i == 0) {
        array.push(true);
      } else {
        array.push(false);
      }
    }
    setArrows(array);
  }, []);

  return (
    <div className={styles.Steps}>
      <div className={styles.title}>{title}</div>
      <div
        className={styles.line}
        style={{
          display: isBelowLarge ? null : "none",
        }}
      ></div>
      <div className={styles.flexbox}>
        {steps.content.map((d, i) => (
          <div key={"step-" + i} className={styles.stepHead}>
            <div className={styles.circle}>{i + 1}</div>
            <div
              style={{
                fontWeight: "bold",
                display: isBelowLarge ? "none" : null,
              }}
            >
              {steps.titles[i]}
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: d }}
              className={styles.content}
              style={{ display: isBelowLarge ? "none" : null }}
            ></div>
            <button
              style={{ display: isBelowLarge ? null : "none !important" }}
              onClick={() => handleClick(d, i)}
            >
              {steps.subtitles[i]}
              <div
                className={`${styles.arrowContainer} ${
                  close || !arrows[i] ? styles.arrowContainerClosed : null
                }`}
              >
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={styles.arrow}
                  style={{
                    transform: arrows[i] == true ? "rotate(-180deg)" : null,
                    transition: "all .5s ease",
                  }}
                />
              </div>
            </button>
          </div>
        ))}
      </div>
      <div
        className={`${styles.card} ${close ? styles.closed : null}`}
        style={{ display: isBelowLarge ? "block" : "none" }}
      >
        <div className={styles.closeIcon}>
          <Close onClick={handleClose} />
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: cardContent }}
          className={styles.cardContent}
        ></div>
      </div>
    </div>
  );
};
export default Steps;
